import { query } from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute , Router} from "@angular/router";
// import { Router } from "@angular/router";
import { SessionDataService } from "../session-data.service";

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private data: SessionDataService) { }

  params: any;
title: any;
details: any;
StartDate: any;
EndDate: any;
date: any;
countries: any[];
displayDate: string;
fullDate: string;
Months: any[];
public sponsorList: any[];



  ngOnInit(): void {

    this.data.uncheckAll();

    this.Months=['January','February','March','April','May','June','July','August','September','October','November','December']


    this.countries = ["United States","Canada","Afghanistan","Åland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua And Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State Of)","Bonaire, Sint Eustatius And Saba","Bosnia And Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cabo Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Democratic Republic Of The Congo","Cook Islands","Costa Rica","Côte D’ivoire","Croatia","Cuba","Curaçao","Cyprus","Czechia","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island And Mcdonald Islands","Holy See","Honduras","China, Hong Kong Special Administrative Region","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic Of)","Iraq","Ireland","Isle Of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Democratic People's Republic Of Korea","Republic Of Korea","Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","China, Macao Special Administrative Region","North Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States Of)","Republic Of Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","State Of Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Réunion","Romania","Russian Federation","Rwanda","Saint Barthélemy","Saint Helena","Saint Kitts And Nevis","Saint Lucia","Saint Martin (French Part)","Saint Pierre And Miquelon","Saint Vincent And The Grenadines","Samoa","San Marino","Sao Tome And Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch Part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia And The South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard And Jan Mayen Islands","Eswatini","Sweden","Switzerland","Syrian Arab Republic","Taiwan, Republic Of China","Tajikistan","United Republic Of Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad And Tobago","Tunisia","Turkey","Turkmenistan","Turks And Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom Of Great Britain And Northern Ireland","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic Of)","Viet Nam","British Virgin Islands","United States Virgin Islands","Wallis And Futuna Islands","Western Sahara","Yemen","Zambia","Zimbabwe","Sark"]

    // this.data.getEventDetails(params.keyword);
   this.activatedRoute.queryParams.subscribe(params => {
    this.data.uncheckAll();
   this.params = params
   this.title = this.params.keyword

   this.data.getEventDate(this.params.ID).subscribe((res: any[])=>{
    this.sponsorList = res ['EventSponsors']
    this.date = res;
console.log(res)
if(this.date.RegistrationUrl !== null){
  document.getElementById("registration").innerHTML = `<a class="registerButton" href=${this.date.RegistrationUrl}>Register</a>`
}else{
  document.getElementById("registration").innerHTML = ""
}
    this.sponsorList.forEach(sponsor => {
     
    })
    this.StartDate = new Date(this.date.StartDateLocal);
    this.EndDate  = new Date(this.date.EndDateLocal)
  
    if(this.EndDate.getDate() !== this.StartDate.getDate()){
      this.fullDate = `${this.Months[this.StartDate.getMonth()]} ${this.StartDate.getDate()}, ${this.StartDate.getFullYear()} - ${this.Months[this.EndDate.getMonth()]} ${this.EndDate.getDate()}, ${this.EndDate.getFullYear()}`
      
    }else if(this.EndDate.getDate() == this.StartDate.getDate()){
      this.fullDate = `${this.Months[this.StartDate.getMonth()]} ${this.StartDate.getDate()}, ${this.StartDate.getFullYear()}`
      
    }
    document.getElementById("sponsors").innerHTML = ""
if(this.sponsorList.length !== 0){
  let sponsorHTML = "<h1>Sponsors</h1> <div class=sponsorsList>";
this.sponsorList.forEach(sponsor => {
  sponsorHTML = sponsorHTML + `<a href=${sponsor.SponsorUrl}> <div class='sponsor'>
  <img src=${sponsor.ImageUrl} class="sponsorLogo">
  <span>${sponsor.Name}</span>
</div></a>`

});
sponsorHTML = sponsorHTML + "</div>"
  document.getElementById("sponsors").innerHTML = sponsorHTML
  
}



  })
  
    this.data.getEventDetails(this.params.ID).subscribe((res: [])=>{
      console.log(res)
      this.details = res;  
      if(this.details.CountryId == null){
        document.getElementById("location").innerHTML = this.details.Address1
      }else{
        document.getElementById("location").innerHTML = `${this.details.City}, ${this.details.StateProvince} ${this.countries[this.details.CountryId - 1]}`
      }
      document.getElementById("description").innerHTML = `${this.details.Description}`
      document.getElementById("banner").innerHTML = ``
   
      if(this.details.Images[0] !== undefined) {
        console.log(this.details.Images[0])
        document.getElementById("banner").innerHTML = `<Img src=${this.details.Images[0].Url} class="banner">`

      }  
          })

          this.data.getEventFiles(this.params.ID).subscribe((res: any) => {
            let files = []
            // let fullFiles = res.EventFiles
            document.getElementById("AdditionalResources").innerHTML = ''
            res.EventFiles.forEach(file => {
              if(file.ContentType ==  "application/pdf" && file.IsShared == true){
                files.push(file)
              }
            });
            if(files.length !== 0){
              document.getElementById("AdditionalResources").innerHTML = "<h1>Additional Resources</h1><div id='ResourceList'></div>"
              let filesHTML: any = ""
              files.forEach(file => {
                let shareUrl;
                this.data.getFileShare(file.FileId).subscribe((res: any) => {
                  shareUrl = res.PublicUrl;
                  filesHTML = filesHTML + `<a href=${shareUrl} target="_blank" rel="noopener noreferrer"><span>${file.Name}</span></a> `
                  document.getElementById("ResourceList").innerHTML = filesHTML
                  
                })
              
              });
              

            }
          })
          
          
            
 
   }
   )

  }

 
  
}
